/* Polsk katalog for locale-invoice-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'control.expand': 'Rozwiń czat',
  'control.collapse': 'Zmniejsz czat',
  'control.proposalIncomplete': 'Propozycja faktury jest niekompletna. Linie i szczegóły nie są uzupełnione. Podaj brakujące dane lub dokończ w formularzu.',
  'control.reloadRequired': 'Tryb faktury został zaktualizowany. Załaduj stronę ponownie, zanim przejdziesz dalej. Żadne pole nie zostało zmienione.',
  'control.fieldsApplied': 'Klient i linie faktury zostały wpisane do formularza. Szkic nie jest zapisany.',
  'control.customerApplied': 'Klient jest wybrany w formularzu faktury.',
  'control.onepageApplied': 'Widok zmieniono na wszystko na jednej stronie.',
  'control.stepsApplied': 'Widok zmieniono na wypełnianie krok po kroku.',
  'control.editorOpened': 'Strona nowej sprzedaży jest otwarta.',
  'control.listOpened': 'Lista faktur jest otwarta.',
  'control.saveReady': 'Szkic można zapisać, gdy mnie o to poprosisz.',
  'control.noChange': 'Żadne pole nie zostało zmienione. Opisz, co chcesz wpisać na fakturze.',
  'control.title': 'SuperPlumma wykonuje pracę',
  'control.scope': 'Co chcesz zrobić?',
  'control.you': 'Ty',
  'control.input': 'Co chcesz zrobić?',
  'control.run': 'Wykonaj',
  'control.speak': 'Głos',
  'control.stopMic': 'Anuluj mowę',
  'control.stop': 'Zatrzymaj',
  'control.minimize': 'Zminimalizuj asystenta',
  'control.newChat': 'Rozpocznij nową rozmowę',
  'control.working': 'Plumme pracuje …',
  'control.saved': 'Szkic jest zapisany. Faktura nie została wysłana.',
  'control.reviewHelp': 'Sprawdź fakturę w podglądzie. Aby dokończyć, użyj „Utwórz fakturę” i zwykłych opcji wysyłki.',
  'control.save': 'Zapisz szkic',
  'control.listening': 'Słucham …',
  'control.voiceUnsupported': 'Ta przeglądarka nie obsługuje tutaj mowy. Nadal możesz pisać.',
  'control.voiceFailed': 'Nie udało się rozpoznać mowy. Sprawdź dostęp do mikrofonu lub napisz wiadomość.',
  'control.editorUnavailable': 'Edytor faktur jest niedostępny. Otwórz fakturę i spróbuj ponownie.',
  'control.editorChanged': 'Faktura zmieniła się w trakcie mojej pracy. Poproś o zmianę ponownie, a użyję najnowszych pól.',
  'control.invoiceOnly': 'Ten tryb obsługuje faktury. Do innych zadań użyj zwykłego asystenta.',
  'control.agentUnavailable': 'Tryb faktury wymaga nowej usługi asystenta, która jest teraz niedostępna. Nie wprowadzono żadnej zmiany.',
  'control.advancedInvoice': 'Ta faktura zawiera szczegóły, które w pierwszej wersji trzeba edytować w formularzu. Żadne pole nie zostało zmienione.',
  'control.customerRequired': 'Wybierz istniejącego klienta lub najpierw utwórz klienta w rejestrze klientów.',
  'control.incomplete': 'Przed zapisaniem wybierz klienta i dodaj linię faktury.',
  'control.saveBeforeLeaving': 'Zapisz szkic, zanim przejdziesz do listy faktur, aby zachować zmiany.',
  'control.failed': 'Nie udało się wykonać zadania. Spróbuj ponownie.',
  'pageControl.working': 'Praca na stronie ...',
  'pageControl.done.applied': 'Pola zostały zaktualizowane na zwykłej stronie.',
  'pageControl.done.saved': 'Akcja została wykonana przez zwykły proces zapisu strony.',
});
